import { SVGFC } from '@repo/toolkit/types'

const SearchIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0997 15.0201L16.6663 17.5868M15.9255 10.5709C15.9255 14.0601 13.1063 16.8884 9.62967 16.8884C6.15217 16.8884 3.33301 14.0601 3.33301 10.5718C3.33301 7.08092 6.15217 4.25342 9.62884 4.25342C13.1063 4.25342 15.9255 7.08175 15.9255 10.5709Z"
        stroke={color}
        strokeWidth="1.11111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SearchIcon
